export const role = {
  Back_Office: "Back_Office", //Customer Care
  Dental_Assistant: "Dental_Assistant", //Sestra
  Doctor: "Doctor", //Doktor
  Floor_Manager: "Floor_Manager", //Floor Manager
  Front_Office: "Front_Office", //Recepce
  Treatment_Coordinator: "Treatment_Coordinator", //Koordinator
  Location_Manager: "Location_Manager", // Location Manager
  Manager_Customer_Care: "Manager_Customer_Care",
  Manager_Clinic: "Manager_Clinic",
  Read_Only: "Read_Only",
  Read_Only_Full: "Read_Only_Full",
};

/**
 * Some places in the app require to show 1 role of the user.
 * This is list of priorities (which role we show):
 */
const rolePriority = [
  role.Manager_Clinic,
  role.Manager_Customer_Care,
  role.Doctor,
  role.Floor_Manager,
  role.Treatment_Coordinator,
  role.Back_Office,
  role.Front_Office,
  role.Dental_Assistant,
];

/**
 * @param {Set<string>} roles
 *
 * @returns {string}
 */
export function getHighestPriorityRole(roles) {
  return rolePriority.find((r) => roles.has(r));
}

/**
 * @param {object} roles
 *
 * @returns {string[]}
 */
export function grantedLocations(roles) {
  return Object.keys(roles ?? {});
}

/**
 * @param {Set<string>} currentRoles
 * @param {Set<string>} [requiredRoles]
 */
export function isGrantedAny(currentRoles, requiredRoles) {
  if ((requiredRoles?.size ?? 0) === 0) {
    return true;
  }

  return currentRoles.intersection(requiredRoles).size > 0;
}
